import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import app from './modules/app'
import directories from './modules/directories'
import auth from './modules/auth'
import reservationForm from './modules/reservationForm'
import availabilities from './modules/availabilities'
import retrieveReservation from './modules/retrieveReservation'
import geolocation from './modules/geolocation'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      app,
      directories,
      auth,
      reservationForm,
      availabilities,
      retrieveReservation,
      geolocation
    },
    getters,

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV
  })

  return Store
}
